// extracted by mini-css-extract-plugin
export default {"summary_card":"summaryCard_summary_card__hxfhI","header":"summaryCard_header__PwA6t"};